/*
 * @Author: ljc_625738144@qq.com
 * @Date: 2024-08-15 15:52:04
 * @LastEditors: ljc_625738144@qq.com
 * @LastEditTime: 2024-08-27 11:03:40
 * @Description: 常量js文件
 * @FilePath: \haozhang_pro\src\assets\js\constant.js
 */

// 弹框大小常量
export const DIALOG_SIZE = {
  SMALL: '400px',
  MEDIUM: '600px',
  LARGE: '800px',
  EXTRA_LARGE: '1200px'
}
export const BUTTON_SIZE = {
  SMALL: '64px',
  MEDIUM: '80px',
  LARGE: '100px',
  EXTRA_LARGE: '120px',
}



// WEBPACK FOOTER //
// ./src/assets/js/constant.js